import React, { type FC } from 'react';
import PropTypes from 'prop-types';

import { Link } from '@confluence/route-manager/entry-points/Link.ts';

export const PeopleLink: FC<any> = (props) => {
	const { href, to, children, ...otherProps } = props;
	const url = to || href;

	return (
		<Link href={url} to={to} {...otherProps}>
			{children}
		</Link>
	);
};

PeopleLink.propTypes = {
	href: PropTypes.string,
	to: PropTypes.string,
};
